import clsx from "clsx";
import { observer } from "mobx-react";
import SidebarChatList from "./SidebarChatList";
import SidebarChatsShortcut from "./SidebarChatsShortcut";
import SidebarDocuments from "./SidebarDocuments";
import SidebarFooter from "./SidebarFooter";
import SidebarHeader from "./SidebarHeader";
import SidebarNewChatButton from "./SidebarNewChatButton";
import SidebarProjects from "./SidebarProjects";
import "./Sidebar.scss";

type SidebarProps = {
  collapsed: boolean;
  onToggleCollapse: () => void;
  onExpandSidebar: () => void;
  onOpenSearch: () => void;
  onNavigate?: () => void;
};

const Sidebar = observer(function Sidebar({
  collapsed,
  onToggleCollapse,
  onExpandSidebar,
  onOpenSearch,
  onNavigate,
}: SidebarProps) {
  return (
    <aside className={clsx("sidebar", collapsed && "sidebar--collapsed")}>
      <SidebarHeader
        collapsed={collapsed}
        onToggleCollapse={onToggleCollapse}
        onOpenSearch={onOpenSearch}
        onNavigate={onNavigate}
      />

      <div className="sidebar__actions">
        <SidebarNewChatButton collapsed={collapsed} onNavigate={onNavigate} />
        {collapsed ? <SidebarChatsShortcut onExpand={onExpandSidebar} /> : null}
      </div>

      {!collapsed ? (
        <div className="sidebar__scroll">
          <SidebarProjects />
          <SidebarDocuments />
          <SidebarChatList onNavigate={onNavigate} />
        </div>
      ) : null}

      <SidebarFooter collapsed={collapsed} />
    </aside>
  );
});

export default Sidebar;
